<template>
  <div class="row-content">
    <div class="row-title">
      <span>用户登录数量汇总</span>
      <span
        class="btn"
        :class="{ 'btn-active': userLoginNav === 'day' }"
        @click="handleLoginDataNavChange('day')"
        >“日”登录量</span
      >
      <!-- <span class="btn" :class="{ 'btn-active': userLoginNav === 'week'}"
                                      @click="handleLoginDataNavChange('week')">7日登录量</span> -->
      <span
        class="btn"
        :class="{ 'btn-active': userLoginNav === 'month' }"
        @click="handleLoginDataNavChange('month')"
        >“月”登录量
      </span>
      <span
        class="btn"
        :class="{ 'btn-active': userLoginNav === 'year' }"
        @click="handleLoginDataNavChange('year')"
        >“年”登录量</span
      >
      <span class="title" style="color: #fac858; margin-left: 0.5rem"
        >当前在线： {{ onlineCoachCount }}人</span
      >
    </div>
    <div class="data-wrapper">
      <div class="echart-user-login" id="echart-user-login"></div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
var moment = require("moment");

export default {
  props: {
    propsLoginInfo: {
      type: Object,
      required: true,
    },
    onlineCoachCount: {
      type: Number,
      required: true,
      default: 0,
    },
    propsReloadTime: {
      type: Number,
      required: false,
      default: 30000
    }
  },

  data() {
    return {
      // onlineCount: 10,
      userLoginNav: "day",
      userLoginTimer: null, // 自动切换定时器
      clickTimer: null, //  点击定时器
      seriesData: [],
      xAxisData: [],
      navCount: 0,
    };
  },

  watch: {
    // 用户登录数量统计
    userLoginNav: function (newVal, oldVal) {
      this.initPage();
    },
  },

  computed: {
    lineOptions() {
      const options = {
        title: {
          text: "",
        },
        tooltip: {
          trigger: "axis",
        },

        grid: {
          left: "3%",
          right: "7%",
          bottom: "13%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisLine: {
            show: true,
            lineStyle: {
              color: "#61a8ff",
              width: 1,
              type: "solid",
            },
          },
          data: this.xAxisData,
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: true,
            lineStyle: {
              color: "#61a8ff",
              width: 1,
              type: "solid",
            },
          },
          nameTextStyle: {
            color: ["#FFFFFF"],
          },
        },
        legend: {
          data: [],
          show: true,
          textStyle: {
            color: "#61a8ff",
          },
        },
        color: ["#68d8fe", "#fac858", "#ee6666", "#73c0de"],
        series: [
          {
            name: "用户登录数量",
            type: "line",
            stack: "总量",
            data: this.seriesData,
          },
        ],
      };
      return options;
    },
    orgId() {
      const { id } = this.$route.query;
      return id;
    },
  },

  mounted() {
    this.initPage();
  },
  methods: {
    initPage() {
      const xAxisData = this.constructTimeSequelize2EchartsXAxis(
        this.userLoginNav
      );
      const yAxisData = this.getAimDataByTimeNav(
        this.userLoginNav,
        this.propsLoginInfo,
        xAxisData
      );
      this.seriesData = yAxisData;
      this.xAxisData = xAxisData;
      this.drawLine();
      // if (this.userLoginTimer) clearInterval(this.userLoginTimer);
      // if (this.clickTimer) clearTimeout(this.clickTimer);
      this.autoChangeLoginUser();
    },

    drawLine() {
      const dom = document.getElementById("echart-user-login");
      const lineObj = echarts.init(dom);
      lineObj && lineObj.setOption(this.lineOptions);
    },

    // 用户登录数量汇总
    handleLoginDataNavChange(val) {
      if (this.userLoginTimer) clearInterval(this.userLoginTimer);
      if (this.clickTimer) clearTimeout(this.clickTimer);
      this.userLoginNav = val;
      this.clickTimer = setTimeout(() => {
        this.autoChangeLoginUser();
      }, 10000);
    },

    // 自动更换用户登录表格
    autoChangeLoginUser() {
      if (this.userLoginTimer) clearInterval(this.userLoginTimer); // 保证只存在一个定时器
      // const userLoginNavList = ['day', 'week', 'month', 'year',];
      const userLoginNavList = ["day", "month", "year"];
      // const userLoginNavList = ['day', 'week', 'month'];
      const that = this;
      that.userLoginTimer = setInterval(function () {
        that.navCount += 1;
        if (that.navCount > 2) that.navCount = 0;
        that.userLoginNav = userLoginNavList[that.navCount];
      }, 10000);
    },

    // 生成时间序列，用来做填充echart数据的基础模板
    constructTimeSequelize2EchartsXAxis(status = "") {
      let xAxis = [];
      switch (status) {
        case "day":
          for (let i = 0; i < 30; i++) {
            let unshiftDate = moment().subtract(i, "days").format("yyyy-MM-DD");
            xAxis.unshift(unshiftDate);
          }
          break;
        case "week":
          for (let i = 0; i < 7; i++) {
            let unshiftDate = moment().subtract(i, "days").format("yyyy-MM-DD");
            xAxis.unshift(unshiftDate);
          }
          break;
        case "month":
          for (let i = 0; i < 12; i++) {
            let unshiftDate = moment().subtract(i, "months").format("yyyy-MM");
            xAxis.unshift(unshiftDate);
          }
          break;
        case "year":
          for (let i = 0; i < 4; i++) {
            let unshiftDate = moment().subtract(i, "years").format("yyyy");
            xAxis.unshift(unshiftDate);
          }
          break;
      }
      if (xAxis.length) {
        return xAxis;
      } else {
        return false;
      }
    },

    // 根据用户操作选择当前数据源
    getAimDataByTimeNav(status, sourceData = {}, xAxisData = []) {
      let sourceSeriesData = [];
      switch (status) {
        case "day":
          sourceSeriesData = sourceData["loginInfoDay"] || [];
          break;
        case "week":
          sourceSeriesData = sourceData["loginInfoWeek"] || [];
          break;
        case "month":
          sourceSeriesData = sourceData["loginInfoMonth"] || [];
          break;
        case "year":
          sourceSeriesData = sourceData["loginInfoYear"] || [];
          break;
      }
      // 将数组转为map对象方便取值（字典）
      let sourceMap = {};
      sourceSeriesData.forEach((item) => {
        const { MINUTE: value, MONTH: key } = item;
        sourceMap[key] = value;
      });
      let seriesData = [];
      if (xAxisData.length) {
        xAxisData.forEach((xAxisItem) => {
          if (sourceMap[xAxisItem]) {
            seriesData.push(sourceMap[xAxisItem]);
          } else {
            seriesData.push(0);
          }
        });
      } else {
        throw new Error("缺少图标横轴数据");
      }
      return seriesData;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.row-content
  padding 1.25rem 0
  .row-title
    color #68d8fe
    font-weight 600
    font-size 16px
    margin-bottom 0.4rem
    display flex
    align-items center
    .btn
      display flex
      align-items center
      justify-content center
      width 7rem
      height 2rem
      font-size 0.8rem
      // margin 0 5px
      border-radius 2px
      cursor pointer
      padding-right 0.5rem
      margin 0 0.3rem
    .btn-active
      background-color #0bace6
      color #FFFFFF
  .data-wrapper
    display flex
    flex-wrap wrap
    .echart-user-login
      height 290px
      width 100%
</style>

